/* eslint-disable */
export default {
  noResultFoundFor: 'Ei tuloksia haulla',
  search: 'Haku',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
